import request from '@/utils/request'

export function getJsSign(params) {
  return request({
    url: '/wechat/getJsSign',
    method: 'get',
    params,
  })
}

export function getOauthRedirect(params) {
  return request({
    url: '/wechat/getOauthRedirect',
    method: 'get',
    params,
  })
}

export function wxLogin(params) {
  return request({
    url: '/wechat/wxLogin',
    method: 'get',
    params,
  })
}